import HttpClientToken from '../../services/HttpClientToken';

import { TipoPromocionProps, defaultTipoPromocion } from '../../interfaces/catalogos/TipoPromocionInterface';

export const TiposPromocion = () => {

    return new Promise<TipoPromocionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPromocion/', token)
            .then( ({ data } : { data : TipoPromocionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoPromociones = () => {

    return new Promise<TipoPromocionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPromocion/ObtenerTipoPromociones', token)
            .then( ({ data } : { data : TipoPromocionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoPromocion = ( params: TipoPromocionProps ) => {

    return new Promise<TipoPromocionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPromocion/Actualizar', params, token)
            .then( ({ data } : { data : TipoPromocionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPromocion } );
            });

        }

    });

}

export const AgregarTipoPromocion = ( params: TipoPromocionProps ) => {

    return new Promise<TipoPromocionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPromocion/Agregar', params, token)
            .then( ({ data } : { data : TipoPromocionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPromocion } );
            });

        }

    });

}
